import { ReactNode, useEffect, ReactElement } from 'react';

import { OverlayLoading } from '../components';
import { useShowLoading } from '../contexts/ShowLoading';

export function Root({ children }: { children: ReactNode }): ReactElement {
  const { showLoading } = useShowLoading();

  useEffect(() => {
    window.hideSplash();
  }, []);

  return (
    <>
      <OverlayLoading loading={showLoading} />
      {children}
    </>
  );
}
